// @ts-nocheck
import React, { useState, useContext, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme/';
import Fetch from '@/utils/Fetch';
import SettingsMenu from '@/components/settings/menu';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import ManageWebForm from '@/components/webform/manage';
import { createFileRoute } from '@tanstack/react-router'

function EditWebForm() {

    const router = useRouter();
    const { id } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch

    let currPath = '';
    if (Router.router) {
        currPath = Router.router.asPath;
    }

    const { data: webFormData } = useQuery(
        ['webForm', id],
        () => Fetch.get({ url: '/WebForm', params: { webFormID: id } }),
        { enabled: !!id }
    );
    const [webForm, setWebForm] = useState<any>(null);
    useEffect(() => {
        if (webFormData && !webForm) {
            setWebForm(webFormData);
        }
    }, [webFormData]);

    const [formIsDirty, setFormIsDirty] = useState(false);
    const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
    const [customerStatus, setCustomerStatus] = useState<any>(null);
    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
            setCustomerStatus(subscriptionInfo.CustomerStatus);
        }
    }

    useEffect(() => {
        getAccessStatus();
    }, []);

    useEffect(() => {
        if ((accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) && customerStatus !== "Trial" && customerStatus !== null) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus, customerStatus]);

    Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions);

    if (!webForm) return null;

    return (
        <div className="settings-container">
            <div className="row">
                <SettingsMenu urlPath={currPath} />
                <ManageWebForm
                    isNew={false}
      
                    webFormToEdit={webForm}
                />
            </div>

            <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

            <style jsx>{`

          
            .style-heading {
                margin: 24px 0 8px 0;
                font-weight: bold;
            }

            .actions {
                margin-top: 1rem;
                padding-bottom: 1rem;
                display: flex;
                flex-direction: row-reverse;
              }
      
              .actions :global(.button){
                margin-left: 0.5rem;
                margin-top: 0;
                padding: 0 1rem;
                white-space: nowrap;
            }

        .copy-button {
            background: lightgrey;
                padding: 8px;
                border-radius: 3px;
                border: none;
                cursor: pointer;
        }

            .code {
                background: lightgrey;
                padding: 8px;
                border-radius: 3px;
                line-height: 32px;
            }

        .add-location {
          align-items: center;
          color: ${colors.bluePrimary};
          cursor: pointer;
          display: flex;
          font-weight: bold;
        }
        .add-location img {
          margin: 2px 0.5rem 0 0;
        }
        .container {
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          height: 100%;
          padding: 1.5rem 3rem;
          overflow-x: hidden;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: ${layout.inputWidth};
        }
        .column + .column {
            margin-left: 1.25rem;
        }
        .column-end {
            align-items: flex-end;
        }
        .column.narrow {
            width: 90px;
            min-width: 90px;
            padding-top: 2rem;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .title {
          align-items: center;
          color: ${colors.darkPrimary};
          display: flex;
          height: 2.5rem;
          width: 100%;
        }
        .title h1 {
          font-size: 32px;
          margin: 6px 0 2rem 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }
        .row {
          display: flex;
        }
        .row-align {
          align-items: center;
          height: 1.75rem
        }
        .empty {
          align-items: center;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          height: fit-content;
          justify-content: center;
          margin-left: 1.5rem;
          width: 520px;
        }
        .empty img {
          height: 110px;
          margin-bottom: 1rem;
        }
        .empty h3 {
          color: ${colors.darkSecondary};
          font-size: 16px;
          margin: 0 0 0.75rem;
        }
        .empty p {
          color: ${colors.blueGrey};
          margin: 0;
          text-align: center;
        }
      `}</style>

        </div>
    );
}

export default EditWebForm;

export const Route = createFileRoute('/_authenticated/settings/webform/$id')({ component: EditWebForm })
